<template>
  <b-row class="text-left">
    <b-col>
      <div class="m-1 mt-4" v-for="company in this.userCompanies" :key="company.id">
        <h2 v-if="company.companyData.short_name[0]" class="mb-4">
          {{ company.companyData.short_name[0].name }}
        </h2>

        <h2 v-if="company.companyData.long_name[0] && !company.companyData.short_name[0]" class="mb-4">
          {{ company.companyData.long_name[0].name }}
        </h2>
        <section v-if="favouritesList.find(list => list.companyId == company.companyId)">
          <div
            class="mt-4 competition-box-wrapper rounded"
            v-for="competition in company.competitions"
            :key="competition._id"
          >
            <div
              class="userCompany-name d-flex justify-content-between"
              v-b-toggle="'userCompany-' + company.id + '-competition-' + competition._id"
            >
              <div class="mb-4">
                <h3 class="text-green">{{ competition.name }}</h3>

                <p class="application-type m-0">{{ getAppType(competition.type) }}</p>
              </div>

              <BookmarkSvg @click.native="removeFromFavorites(company, competition._id)" style="cursor: pointer" />
            </div>

            <favourite-competition-small-details :competition="competition" />
          </div>
        </section>
        <section v-else class="d-flex no-competitions-wrapper">
          <div class="col-6 d-flex align-items-center justify-content-center">
            <p class="no-favourites-text">Még nincsenek lehetőségek elmentve a kedvencek közé!</p>
          </div>
          <div class="col-6">
            <img
              src="../../../assets/img/favourites-background.png"
              alt="favourites-background"
              class="background-image"
            />
          </div>
        </section>
      </div>
      <div
        class="m-1 mt-4"
        v-for="imaginaryUserCompany in this.imaginaryUserCompanies"
        :key="imaginaryUserCompany.companyId"
      >
        <h2 v-if="imaginaryUserCompany.companyData.name" class="mb-4">
          {{ imaginaryUserCompany.companyData.name }}
        </h2>
        <section v-if="imaginaryFavouritesList.find(list => list.companyId === imaginaryUserCompany.companyId)">
          <div
            class="mt-4 competition-box-wrapper rounded"
            v-for="imagCompetition in imaginaryUserCompany.competitions"
            :key="imagCompetition._id"
          >
            <div
              class="userCompany-name d-flex justify-content-between"
              v-b-toggle="'userCompany-' + imaginaryUserCompany.id + '-imagCompetition-' + imagCompetition._id"
            >
              <div class="mb-4">
                <h3 class="text-green">{{ imagCompetition.name }}</h3>

                <p class="application-type m-0">{{ getAppType(imagCompetition.type) }}</p>
              </div>

              <BookmarkSvg
                @click.native="removeFromFavorites(imaginaryUserCompany, imagCompetition._id)"
                style="cursor: pointer"
              />
            </div>

            <favourite-competition-small-details :competition="imagCompetition" />
          </div>
        </section>
        <section v-else class="d-flex no-competitions-wrapper">
          <div class="col-6 d-flex align-items-center justify-content-center">
            <p class="no-favourites-text">Még nincsenek lehetőségek elmentve a kedvencek közé!</p>
          </div>
          <div class="col-6">
            <img
              src="../../../assets/img/favourites-background.png"
              alt="favourites-background"
              class="background-image"
            />
          </div>
        </section>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import BookmarkSvg from '../../../components/svg/Bookmark.vue'
import FavouriteCompetitionSmallDetails from './FavouritesCompetitionSmallDeatails.vue'
import { getReadableCompetitionType } from '../../../constants/competitionTypes'
import * as ImaginaryUserCompanyApi from '../../../api/imaginaryUserCompany'
import * as ImaginaryCompanyApi from '../../../api/imaginaryCompany'
export default {
  name: 'Opportunities',
  data() {
    return {
      imaginaryUserCompanies: []
    }
  },
  components: {
    BookmarkSvg,
    FavouriteCompetitionSmallDetails
  },
  computed: {
    ...mapGetters(['userCompanies', 'getUser']),
    favouritesList() {
      return this.userCompanies.filter(favourites => favourites.favoriteCompetitionIds.length)
    },
    imaginaryFavouritesList() {
      return this.imaginaryUserCompanies.filter(favourites => favourites.favoriteCompetitionIds.length)
    }
  },
  methods: {
    async getImaginaryUserCompaniesByCompanyId() {
      try {
        this.imaginaryUserCompanies = await ImaginaryUserCompanyApi.getImaginaryUserCompanyByUserId(this.getUser._id)
      } catch (e) {
        console.log(e)
      }
    },
    async removeFromFavorites(userCompany, competitionId) {
      if (userCompany.companyId.toString().length > 8) {
        const filteredImagFavoritCompetitionIds = userCompany.favoriteCompetitionIds.filter(
          favoriteCompetitionId => favoriteCompetitionId !== competitionId
        )

        await ImaginaryCompanyApi.patchImaginaryUserCompanyById(userCompany._id, filteredImagFavoritCompetitionIds)

        this.getImaginaryUserCompaniesByCompanyId()
      } else {
        const filteredFavoriteCompetitionIds = userCompany.favoriteCompetitionIds.filter(
          favoriteCompetitionId => favoriteCompetitionId !== competitionId
        )
        await this.$store.dispatch('patchUserCompany', {
          userCompanyId: userCompany.id,
          favoriteCompetitionIds: filteredFavoriteCompetitionIds
        })

        this.$store.dispatch('getUserCompanies', {})
      }
    },
    getAppType(type) {
      return getReadableCompetitionType(type)
    }
  },
  async created() {
    this.$gtag.event('favourites', {
      event_category: 'user_interaction'
    })
    await this.$store.dispatch('getUserCompanies', {})
    this.getImaginaryUserCompaniesByCompanyId()
  }
}
</script>

<style scoped>
.competition-container {
  position: relative;
  margin-left: 0px;
  margin-right: 0px;
}

.heart-container {
  cursor: pointer;
  position: absolute;
  right: 15px;
}

.no-competitions-wrapper {
  padding: 20px;
  padding-top: 30px;
  min-height: 80px;
  background-color: #f7fbfc;
  min-height: 80px;
  margin-bottom: 10px;
}

.competition-box-wrapper {
  padding: 25px;
  background-color: #f7fbfc;
}

@media screen and (min-width: 768px) {
  .competition-box-wrapper {
    padding: 30px 60px;
  }
}

.userCompany-name {
  color: var(--color-green);
  font-weight: bold;
  cursor: pointer;
}

.competitionbox-holder .btn {
  width: 200px;
  height: 48px;
  padding: 11px;
}

.collapsed > div > div > .when-opened,
:not(.collapsed) > div > div > .when-closed {
  display: none;
}

.collapsed > .when-opened-2,
:not(.collapsed) > .when-closed-2 {
  display: none;
}

.favourites-section-outside {
  background-color: #00903c;
}

.favourites-section-inside {
  background-color: #fffefc;
  border-bottom-right-radius: 100px;
  padding-bottom: 6rem;
}

.heart-icon {
  cursor: pointer;
}

.userCompany-name {
  color: #00903c;
  font-weight: bold;
  cursor: pointer;
}

.when-opened svg,
.when-closed svg {
  fill: var(--color-green);
  cursor: pointer;
  margin-top: -10px;
}

.when-opened-2 svg,
.when-closed-2 svg {
  float: right;
  fill: #ffffff;
  cursor: pointer;
}

.background-image {
  width: 100%;
}
.no-favourites-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  color: #00903c;
  max-width: 300px;
}

@media (max-width: 992px) {
  .no-favourites-text {
    font-size: 16px;
  }
}
.application-type {
  padding: 4px 8px;
  border-radius: 100px;
  font-weight: 500;
  font-size: 12px;
  color: #000;
  background-color: #dfe6e9;
  width: max-content;
}
</style>
